import React from 'react';
import { TableCell } from '../TableCell';
import ILink from '../../../../types/ILink';
import { PageLinkExtendedInfo } from '../../../../_lib/components/PageLinkExtendedInfo';
import { PagePackState, PagePackStates } from '../../../../types/api/PagePackState';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { InvisiblyDefinedTerm } from '../../../../_lib/components/InvisiblyDefinedTerm';
import { ICategory } from '../../../../types/ICategory';
import { BADGE_STATUS, StatusBadge } from '../../../../_lib/components/Badge';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { ExtendedInfoSVG } from '../../../../_lib/components/ExtendedInfo';
import { Icons } from '../../../atoms/SVG';

type TableCellPageLink = {
  label: string;
  pageLink: ILink;
  pagePackState?: PagePackStates;
  archiveDate?: string;
  integrated?: boolean;
  cellProperties?: TableCell;
  categories?: ICategory[];
};
export function TableCellPageLink({
  label,
  cellProperties,
  pageLink,
  pagePackState,
  categories,
  archiveDate,
  integrated,
}: TableCellPageLink) {
  const { t } = useSonTranslation('glossary');

  return (
    <TableCell {...cellProperties} modifier="postiion-relative" dataHead={label}>
      {categories && categories.length > 0
        ? (
            <>
              {categories.at(0)?.hexColor
                ? (
                    <div className="tables__category-border" style={{ backgroundColor: categories.at(0)?.hexColor }} />
                  )
                : null}
              <InvisiblyDefinedTerm
                className="tables__category"
                definition={t(`category${categories.length > 1 ? '_plural' : ''}`)}
              >
                {categories.map(el => el.title).join(', ')}
              </InvisiblyDefinedTerm>
            </>
          )
        : null}
      <div className="tables__page-link">
        <PageLinkExtendedInfo
          highlightText={false}
          pageLink={pageLink}
          stateIndicatorStatus={pagePackState === PagePackState.ONLY_DRAFT_VERSION ? 'red' : undefined}
        />
        {integrated
          ? (
              <span className="tables__page-link-extended-info">
                <ExtendedInfoSVG
                  helpText={t('integratedPage')}
                  tooltipPlacement={TooltipPlacement.TOP}
                  svgSpriteID={Icons.CONNECTIONS}
                />
              </span>
            )
          : null}
        {archiveDate
          ? (
              <div className="tables__archived-container">
                <StatusBadge status={BADGE_STATUS.ARCHIVED} archiveDate={archiveDate} />
              </div>
            )
          : null}
      </div>
    </TableCell>
  );
}
